<template>
  <div>
    <a
      class="text-center d-block"
      v-if="documento"
      :href="`${awsURL}/${encodeURIComponent(documento.nomeInterno)}`"
      target="_blank"
    >
      <img
        :src="url"
        style="max-width: 100%"
        v-if="documento.extensaoDoc.includes('image') || documento.thumbnail"
      />
      <div v-else>
        <v-icon x-large class="mb-4 accent--text">fas fa-file</v-icon>
        <p>{{ documento.nomeInterno }}</p>
      </div>
    </a>
    <v-row dense v-if="(download || title) && documento.extensaoDoc.includes('image')">
      <v-col
        cols="12"
        sm="10"
        v-if="title"
        class="text-left grey--text"
        style="text-decoration: none"
        >{{ documento.nomeInterno }}</v-col
      >
      <v-col cols="12" sm="2" v-if="download">
        <v-btn
          x-small
          icon
          :href="`${awsURL}/${encodeURIComponent(documento.nomeInterno)}`"
          :download="documento.nomeInterno"
          tag="a"
        >
          <v-icon color="accent">fas fa-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { baseURL, awsURL } from '@/services/container';

export default {
  props: {
    documento: {
      type: Object,
      default: () => {},
    },
    download: {
      type: Boolean,
      default: false,
    },
    title: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseURL,
      awsURL,
      url: '',
    };
  },
  async mounted() {
    await this.checkUrl();
  },
  methods: {
    async checkUrl() {
      const url = `${this.awsURL}/${encodeURIComponent(this.documento.thumbnail || this.documento.nomeInterno)}`;
      const existe = await this.ifUrlExist(url);
      if (existe) this.url = url;
      else this.url = `${this.awsURL}/${encodeURIComponent(this.documento.nomeInterno)}`;
    },
    async ifUrlExist(url) {
      return new Promise((resolve) => {
        const imagem = new Image();
        imagem.onload = function on() {
          resolve(true);
        };
        imagem.onerror = function er() {
          resolve(false);
        };
        imagem.src = url;
      });
    },
  },
};
</script>
